import { keyValueList } from "../../fable_modules/fable-library.3.7.17/MapUtil.js";
import { Union, Record } from "../../fable_modules/fable-library.3.7.17/Types.js";
import { float64_type, obj_type, array_type, anonRecord_type, unit_type, option_type, union_type, lambda_type, record_type, int32_type, class_type, string_type, bool_type } from "../../fable_modules/fable-library.3.7.17/Reflection.js";
import { partialApply } from "../../fable_modules/fable-library.3.7.17/Util.js";
import * as react from "react";
import { Calendar as Calendar_1 } from "react-big-calendar";

function toObj(p) {
    return keyValueList(p, 1);
}

export class CalendarEvent$1 extends Record {
    constructor(allDay, title, start, end, resourceId, metaData) {
        super();
        this.allDay = allDay;
        this.title = title;
        this.start = start;
        this.end = end;
        this.resourceId = (resourceId | 0);
        this.metaData = metaData;
    }
}

export function CalendarEvent$1$reflection(gen0) {
    return record_type("BigCalendar.CalendarEvent`1", [gen0], CalendarEvent$1, () => [["allDay", bool_type], ["title", string_type], ["start", class_type("System.DateTimeOffset")], ["end", class_type("System.DateTimeOffset")], ["resourceId", int32_type], ["metaData", gen0]]);
}

export class CalendarResource$1 extends Record {
    constructor(resourceId, resourceTitle, metaData) {
        super();
        this.resourceId = (resourceId | 0);
        this.resourceTitle = resourceTitle;
        this.metaData = metaData;
    }
}

export function CalendarResource$1$reflection(gen0) {
    return record_type("BigCalendar.CalendarResource`1", [gen0], CalendarResource$1, () => [["resourceId", int32_type], ["resourceTitle", string_type], ["metaData", gen0]]);
}

export class DateRange extends Record {
    constructor(start, end) {
        super();
        this.start = start;
        this.end = end;
    }
}

export function DateRange$reflection() {
    return record_type("BigCalendar.DateRange", [], DateRange, () => [["start", class_type("System.DateTime")], ["end", class_type("System.DateTime")]]);
}

export class Format extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["DayRangeHeaderFormat", "AgendaHeaderFormat", "SelectRangeFormat", "AgendaTimeRangeFormat", "EventTimeRangeFormat", "EventTimeRangeStartFormat", "EventTimeRangeEndFormat"];
    }
}

export function Format$reflection() {
    return union_type("BigCalendar.Format", [], Format, () => [[["Item", lambda_type(DateRange$reflection(), lambda_type(string_type, lambda_type(class_type("BigCalendar.DateLocalizer"), string_type)))]], [["Item", lambda_type(DateRange$reflection(), lambda_type(string_type, lambda_type(class_type("BigCalendar.DateLocalizer"), string_type)))]], [["Item", lambda_type(DateRange$reflection(), lambda_type(string_type, lambda_type(class_type("BigCalendar.DateLocalizer"), string_type)))]], [["Item", lambda_type(DateRange$reflection(), lambda_type(string_type, lambda_type(class_type("BigCalendar.DateLocalizer"), string_type)))]], [["Item", lambda_type(DateRange$reflection(), lambda_type(string_type, lambda_type(class_type("BigCalendar.DateLocalizer"), string_type)))]], [["Item", lambda_type(DateRange$reflection(), lambda_type(string_type, lambda_type(class_type("BigCalendar.DateLocalizer"), string_type)))]], [["Item", lambda_type(DateRange$reflection(), lambda_type(string_type, lambda_type(class_type("BigCalendar.DateLocalizer"), string_type)))]]]);
}

export function Format_DateFormat_Z791EEFAF(value) {
    return [(arg) => {
        const clo = partialApply(2, value, [arg]);
        return (arg_1) => {
            const clo_1 = clo(arg_1);
            return clo_1;
        };
    }, "dateFormat"];
}

export function Format_DateFormat_Z721C83C5(value) {
    return [value, "dateFormat"];
}

export function Format_DayFormat_Z791EEFAF(value) {
    return [(arg) => {
        const clo = partialApply(2, value, [arg]);
        return (arg_1) => {
            const clo_1 = clo(arg_1);
            return clo_1;
        };
    }, "dayFormat"];
}

export function Format_DayFormat_Z721C83C5(value) {
    return [value, "dayFormat"];
}

export function Format_WeekdayFormat_Z791EEFAF(value) {
    return [(arg) => {
        const clo = partialApply(2, value, [arg]);
        return (arg_1) => {
            const clo_1 = clo(arg_1);
            return clo_1;
        };
    }, "weekdayFormat"];
}

export function Format_WeekdayFormat_Z721C83C5(value) {
    return [value, "weekdayFormat"];
}

export function Format_TimeGutterFormat_Z791EEFAF(value) {
    return [(arg) => {
        const clo = partialApply(2, value, [arg]);
        return (arg_1) => {
            const clo_1 = clo(arg_1);
            return clo_1;
        };
    }, "timeGutterFormat"];
}

export function Format_TimeGutterFormat_Z721C83C5(value) {
    return [value, "timeGutterFormat"];
}

export function Format_MonthHeaderFormat_Z791EEFAF(value) {
    return [(arg) => {
        const clo = partialApply(2, value, [arg]);
        return (arg_1) => {
            const clo_1 = clo(arg_1);
            return clo_1;
        };
    }, "monthHeaderFormat"];
}

export function Format_MonthHeaderFormat_Z721C83C5(value) {
    return [value, "monthHeaderFormat"];
}

export function Format_DayHeaderFormat_Z791EEFAF(value) {
    return [(arg) => {
        const clo = partialApply(2, value, [arg]);
        return (arg_1) => {
            const clo_1 = clo(arg_1);
            return clo_1;
        };
    }, "dayHeaderFormat"];
}

export function Format_DayHeaderFormat_Z721C83C5(value) {
    return [value, "dayHeaderFormat"];
}

export function Format_AgendaDateFormat_Z791EEFAF(value) {
    return [(arg) => {
        const clo = partialApply(2, value, [arg]);
        return (arg_1) => {
            const clo_1 = clo(arg_1);
            return clo_1;
        };
    }, "agendaDateFormat"];
}

export function Format_AgendaDateFormat_Z721C83C5(value) {
    return [value, "agendaDateFormat"];
}

export function Format_AgendaTimeFormat_Z791EEFAF(value) {
    return [(arg) => {
        const clo = partialApply(2, value, [arg]);
        return (arg_1) => {
            const clo_1 = clo(arg_1);
            return clo_1;
        };
    }, "agendaTimeFormat"];
}

export function Format_AgendaTimeFormat_Z721C83C5(value) {
    return [value, "agendaTimeFormat"];
}

export class Message extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["Date", "Time", "Event", "AllDay", "Week", "Work_week", "Day", "Month", "Previous", "Next", "Yesterday", "Tomorrow", "Today", "Agenda", "ShowMore", "NoEventsInRange"];
    }
}

export function Message$reflection() {
    return union_type("BigCalendar.Message", [], Message, () => [[["Item", string_type]], [["Item", string_type]], [["Item", string_type]], [["Item", string_type]], [["Item", string_type]], [["Item", string_type]], [["Item", string_type]], [["Item", string_type]], [["Item", string_type]], [["Item", string_type]], [["Item", string_type]], [["Item", string_type]], [["Item", string_type]], [["Item", string_type]], [["Item", lambda_type(int32_type, string_type)]], [["Item", string_type]]]);
}

export function Messages(messages) {
    return toObj(messages);
}

export class EventProps$1 extends Record {
    constructor(Event$, Title, ContinuesPrior, ContinuesAfter, IsAllDay, Localizer, SlotStart, SlotEnd) {
        super();
        this.Event = Event$;
        this.Title = Title;
        this.ContinuesPrior = ContinuesPrior;
        this.ContinuesAfter = ContinuesAfter;
        this.IsAllDay = IsAllDay;
        this.Localizer = Localizer;
        this.SlotStart = SlotStart;
        this.SlotEnd = SlotEnd;
    }
}

export function EventProps$1$reflection(gen0) {
    return record_type("BigCalendar.EventProps`1", [gen0], EventProps$1, () => [["Event", CalendarEvent$1$reflection(gen0)], ["Title", string_type], ["ContinuesPrior", bool_type], ["ContinuesAfter", bool_type], ["IsAllDay", bool_type], ["Localizer", class_type("BigCalendar.DateLocalizer")], ["SlotStart", class_type("System.DateTime")], ["SlotEnd", class_type("System.DateTime")]]);
}

export class ToolbarProps$2 extends Record {
    constructor(date, view, views, label, onNavigate, onView) {
        super();
        this.date = date;
        this.view = view;
        this.views = views;
        this.label = label;
        this.onNavigate = onNavigate;
        this.onView = onView;
    }
}

export function ToolbarProps$2$reflection(gen0, gen1) {
    return record_type("BigCalendar.ToolbarProps`2", [gen0, gen1], ToolbarProps$2, () => [["date", class_type("System.DateTime")], ["view", string_type], ["views", class_type("System.Collections.Generic.IEnumerable`1", [string_type])], ["label", string_type], ["onNavigate", lambda_type(string_type, lambda_type(option_type(class_type("System.DateTime")), unit_type))], ["onView", lambda_type(string_type, unit_type)]]);
}

export class HeaderProps extends Record {
    constructor(Date$, Label, Localizer) {
        super();
        this.Date = Date$;
        this.Label = Label;
        this.Localizer = Localizer;
    }
}

export function HeaderProps$reflection() {
    return record_type("BigCalendar.HeaderProps", [], HeaderProps, () => [["Date", class_type("System.DateTime")], ["Label", string_type], ["Localizer", class_type("BigCalendar.DateLocalizer")]]);
}

export class DateHeaderProps extends Record {
    constructor(date, drilldownView, isOffRange, label, onDrillDown) {
        super();
        this.date = date;
        this.drilldownView = drilldownView;
        this.isOffRange = isOffRange;
        this.label = label;
        this.onDrillDown = onDrillDown;
    }
}

export function DateHeaderProps$reflection() {
    return record_type("BigCalendar.DateHeaderProps", [], DateHeaderProps, () => [["date", class_type("System.DateTime")], ["drilldownView", string_type], ["isOffRange", bool_type], ["label", string_type], ["onDrillDown", lambda_type(unit_type, unit_type)]]);
}

export class ResourceHeaderProps$1 extends Record {
    constructor(label, index, resource) {
        super();
        this.label = label;
        this.index = (index | 0);
        this.resource = resource;
    }
}

export function ResourceHeaderProps$1$reflection(gen0) {
    return record_type("BigCalendar.ResourceHeaderProps`1", [gen0], ResourceHeaderProps$1, () => [["label", class_type("Fable.React.ReactElement")], ["index", int32_type], ["resource", CalendarResource$1$reflection(gen0)]]);
}

export class Components$2 extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["Event", "EventContainerWrapper", "DateCellWrapper", "DayColumnWrapper", "TimeSlotWrapper", "TimeGutterHeader", "TimeGutterWrapper", "Toolbar", "Agenda", "Day", "Week", "Work_week", "Month", "Header", "ResourceHeader"];
    }
}

export function Components$2$reflection(gen0, gen1) {
    return union_type("BigCalendar.Components`2", [gen0, gen1], Components$2, () => [[["Item", class_type("Fable.React.ReactElementType`1", [EventProps$1$reflection(gen0)])]], [["Item", class_type("Fable.React.ReactElementType")]], [["Item", class_type("Fable.React.ReactElementType")]], [["Item", class_type("Fable.React.ReactElementType")]], [["Item", class_type("Fable.React.ReactElementType")]], [["Item", class_type("Fable.React.ReactElementType")]], [["Item", class_type("Fable.React.ReactElementType")]], [["Item", class_type("Fable.React.ReactElementType`1", [ToolbarProps$2$reflection(gen0, gen1)])]], [["Item", anonRecord_type(["date", class_type("Fable.React.ReactElementType")], ["event", class_type("Fable.React.ReactElementType`1", [EventProps$1$reflection(gen0)])], ["time", class_type("Fable.React.ReactElementType")])]], [["Item", anonRecord_type(["event", class_type("Fable.React.ReactElementType`1", [EventProps$1$reflection(gen0)])], ["header", class_type("Fable.React.ReactElementType`1", [HeaderProps$reflection()])])]], [["Item", anonRecord_type(["event", class_type("Fable.React.ReactElementType`1", [EventProps$1$reflection(gen0)])], ["header", class_type("Fable.React.ReactElementType`1", [HeaderProps$reflection()])])]], [["Item", anonRecord_type(["event", class_type("Fable.React.ReactElementType`1", [EventProps$1$reflection(gen0)])], ["header", class_type("Fable.React.ReactElementType`1", [HeaderProps$reflection()])])]], [["Item", anonRecord_type(["dateHeader", class_type("Fable.React.ReactElementType`1", [DateHeaderProps$reflection()])], ["event", class_type("Fable.React.ReactElementType`1", [EventProps$1$reflection(gen0)])], ["header", class_type("Fable.React.ReactElementType`1", [HeaderProps$reflection()])])]], [["Item", class_type("Fable.React.ReactElementType`1", [HeaderProps$reflection()])]], [["Item", class_type("Fable.React.ReactElementType`1", [ResourceHeaderProps$1$reflection(gen1)])]]]);
}

export class SlotInfo extends Record {
    constructor(start, end, slots, action, resourceId, bounds, box) {
        super();
        this.start = start;
        this.end = end;
        this.slots = slots;
        this.action = action;
        this.resourceId = (resourceId | 0);
        this.bounds = bounds;
        this.box = box;
    }
}

export function SlotInfo$reflection() {
    return record_type("BigCalendar.SlotInfo", [], SlotInfo, () => [["start", class_type("System.DateTimeOffset")], ["end", class_type("System.DateTimeOffset")], ["slots", class_type("System.Collections.Generic.IEnumerable`1", [class_type("System.DateTime")])], ["action", string_type], ["resourceId", int32_type], ["bounds", anonRecord_type(["bottom", int32_type], ["left", int32_type], ["right", int32_type], ["top", int32_type], ["x", int32_type], ["y", int32_type])], ["box", anonRecord_type(["clientX", int32_type], ["clientY", int32_type], ["x", int32_type], ["y", int32_type])]]);
}

export class CalendarProp$2 extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["Children", "Localizer", "View", "Events", "BackgroundEvents", "HandleDragStart", "OnNavigate", "OnView", "OnDrillDown", "OnSelectSlot", "OnDoubleClickEvent", "OnSelectEvent", "OnKeyPressEvent", "OnSelecting", "OnShowAllEvents", "Selected", "Views", "DoShowMoreDrillDown", "DrilldownView", "GetDrilldownView", "Length", "Toolbar", "Popup", "LongPressThreshold", "Step", "Timeslots", "Rtl", "EventPropGetter", "SlotPropGetterAccessor", "ShowMultiDayTimes", "Min", "Max", "ScrollToTime", "Culture", "Components", "TitleAccessor", "TooltipAccessor", "AllDayAccessor", "StartAccessor", "EndAccessor", "ResourceAccessor", "Resources", "ResourceIdAccessor", "ResourceTitleAccessor", "DefaultView", "ClassName", "OnShowMore"];
    }
}

export function CalendarProp$2$reflection(gen0, gen1) {
    return union_type("BigCalendar.CalendarProp`2", [gen0, gen1], CalendarProp$2, () => [[["Item", class_type("System.Collections.Generic.IEnumerable`1", [class_type("Fable.React.ReactElement")])]], [["Item", class_type("BigCalendar.DateLocalizer")]], [["Item", string_type]], [["Item", array_type(CalendarEvent$1$reflection(gen0))]], [["Item", array_type(CalendarEvent$1$reflection(gen0))]], [["Item", lambda_type(CalendarEvent$1$reflection(gen0), unit_type)]], [["Item", lambda_type(class_type("System.DateTime"), lambda_type(string_type, lambda_type(string_type, unit_type)))]], [["Item", lambda_type(string_type, unit_type)]], [["Item", lambda_type(class_type("System.DateTime"), lambda_type(string_type, unit_type))]], [["Item", lambda_type(SlotInfo$reflection(), unit_type)]], [["Item", lambda_type(CalendarEvent$1$reflection(gen0), lambda_type(class_type("Browser.Types.Event"), unit_type))]], [["Item", lambda_type(CalendarEvent$1$reflection(gen0), lambda_type(class_type("Browser.Types.Event"), unit_type))]], [["Item", lambda_type(CalendarEvent$1$reflection(gen0), lambda_type(class_type("Browser.Types.Event"), unit_type))]], [["Item", lambda_type(DateRange$reflection(), bool_type)]], [["Item", bool_type]], [["Item", obj_type]], [["Item", class_type("System.Collections.Generic.IEnumerable`1", [string_type])]], [["Item", bool_type]], [["Item", string_type]], [["Item", lambda_type(class_type("System.DateTime"), lambda_type(string_type, lambda_type(array_type(string_type), unit_type)))]], [["Item", float64_type]], [["Item", bool_type]], [["Item", bool_type]], [["Item", float64_type]], [["Item", int32_type]], [["Item", int32_type]], [["Item", bool_type]], [["Item", lambda_type(CalendarEvent$1$reflection(gen0), lambda_type(class_type("System.DateTime"), lambda_type(class_type("System.DateTime"), lambda_type(bool_type, anonRecord_type(["className", string_type])))))]], [["Item", lambda_type(class_type("System.DateTime"), anonRecord_type(["className", option_type(string_type)], ["style", option_type(obj_type)]))]], [["Item", bool_type]], [["Item", class_type("System.DateTime")]], [["Item", class_type("System.DateTime")]], [["Item", class_type("System.DateTime")]], [["Item", string_type]], [["Item", Components$2$reflection(gen0, gen1)]], [["Item", lambda_type(CalendarEvent$1$reflection(gen0), string_type)]], [["Item", lambda_type(CalendarEvent$1$reflection(gen0), string_type)]], [["Item", lambda_type(CalendarEvent$1$reflection(gen0), bool_type)]], [["Item", lambda_type(CalendarEvent$1$reflection(gen0), class_type("System.DateTime"))]], [["Item", lambda_type(CalendarEvent$1$reflection(gen0), class_type("System.DateTime"))]], [["Item", lambda_type(CalendarEvent$1$reflection(gen0), obj_type)]], [["Item", array_type(CalendarResource$1$reflection(gen1))]], [["Item", lambda_type(CalendarResource$1$reflection(gen1), obj_type)]], [["Item", lambda_type(CalendarResource$1$reflection(gen1), obj_type)]], [["Item", string_type]], [["Item", string_type]], [["Item", lambda_type(array_type(CalendarEvent$1$reflection(gen0)), lambda_type(class_type("System.DateTime"), unit_type))]]]);
}

export function CalendarProp$2_SlotPropGetter_55ACF619(getter) {
    return ["slotPropGetter", getter];
}

export function CalendarProp$2_DayLayoutAlgorithm_Z3A793B44(value) {
    return ["dayLayoutAlgorithm", value];
}

export function CalendarProp$2_Formats_4BE8F4B9(value) {
    return ["formats", toObj(value)];
}

export function CalendarProp$2_Messages_6900B931(value) {
    return ["messages", toObj(value)];
}

export function CalendarProp$2_Selectable_Z1FBCCD16(value) {
    return ["selectable", value];
}

export function CalendarProp$2_Selectable_IgnoreEvents() {
    return ["selectable", "ignoreEvents"];
}

export function CalendarProp$2_PopupOffset_5E38073B(value) {
    return ["popupOffset", value];
}

export function CalendarProp$2_PopupOffset_Z57CCE2E1(value) {
    return ["popupOffset", value];
}

export function CalendarProp$2_OnRangeChange_Z33829B90(callback) {
    return ["onRangeChange", callback];
}

export function CalendarProp$2_Date_Z721C83C5(date) {
    return ["date", date];
}

export function CalendarProp$2_Date_7F9DDECF(date) {
    return ["date", date];
}

export function CalendarProp$2_DefaultDate_Z721C83C5(date) {
    return ["defaultDate", date];
}

export function CalendarProp$2_DefaultDate_7F9DDECF(date) {
    return ["defaultDate", date];
}

export function CalendarProp$2_GetNow_5106B011(callback) {
    return ["getNow", callback];
}

export function CalendarProp$2_GetNow_513311E5(callback) {
    return ["getNow", callback];
}

export function Calendar(props) {
    const props_1 = toObj(props);
    return react.createElement(Calendar_1, props_1);
}

